/**
 * First letter of the first word plus first letter of the last word.
 * Matches legacy `Account.userInitials` when the display name is `${first} ${last}`.
 */
export function getDisplayNameInitials(displayName) {
    const trimmed = displayName.trim();
    if (!trimmed) {
        return '';
    }
    const words = trimmed.split(/\s+/);
    const last = words.length > 1 ? words[words.length - 1] : '';
    return `${words[0][0]}${last[0] ?? ''}`;
}
